/**
 * HeyGen Live Avatar Web SDK client for AVG Диалог.
 */
import { LiveAvatarSession, SessionEvent } from '@heygen/liveavatar-web-sdk';

let activeSession: LiveAvatarSession | null = null;

export type HeyGenClientOptions = {
  accessToken: string;
  videoElement: HTMLVideoElement;
  onReady?: () => void;
  onError?: (message: string) => void;
};

export async function startHeyGenAvatar(opts: HeyGenClientOptions): Promise<boolean> {
  await stopHeyGenAvatar();

  if (!opts.accessToken?.trim()) {
    opts.onError?.('Нет access token для HeyGen');
    return false;
  }

  try {
    const session = new LiveAvatarSession(opts.accessToken);
    activeSession = session;

    session.on(SessionEvent.SESSION_STREAM_READY, () => {
      try {
        session.attach(opts.videoElement);
        opts.videoElement.muted = false;
        void opts.videoElement.play().catch(() => undefined);
        opts.onReady?.();
      } catch (err) {
        opts.onError?.(err instanceof Error ? err.message : String(err));
      }
    });

    session.on(SessionEvent.SESSION_DISCONNECTED, () => {
      if (activeSession === session) activeSession = null;
      opts.onError?.('Сессия HeyGen отключена');
    });

    await session.start();
    return true;
  } catch (err) {
    opts.onError?.(err instanceof Error ? err.message : String(err));
    activeSession = null;
    return false;
  }
}

export function speakHeyGenAvatar(text: string): void {
  if (!activeSession || !text.trim()) return;
  activeSession.repeat(text.trim());
}

export function interruptHeyGenAvatar(): void {
  activeSession?.interrupt();
}

export async function stopHeyGenAvatar(): Promise<void> {
  if (activeSession) {
    try {
      await activeSession.stop();
    } catch {
      // ignore stop errors
    }
    activeSession = null;
  }
}

export function isHeyGenAvatarActive(): boolean {
  return activeSession !== null;
}
